/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */
import { IChangePasswordState } from '../types/changePasswordTypes';


export const SUBMIT_CHANGE_PASSWORD_FORM_START = '@@b2b_portal_ui/authorization/SUBMIT_CHANGE_PASSWORD_FORM_START';
export const SUBMIT_CHANGE_PASSWORD_FORM_SUCCESS = '@@b2b_portal_ui/authorization/SUBMIT_CHANGE_PASSWORD_FORM_SUCCESS';
export const SUBMIT_CHANGE_PASSWORD_FORM_FAILURE = '@@b2b_portal_ui/authorization/SUBMIT_CHANGE_PASSWORD_FORM_FAILURE';

export const GET_TEMPORARY_PASSWORD = '@@b2b_portal_ui/authorization/GET_TEMPORARY_PASSWORD';
export const GET_TEMPORARY_PASSWORD_SUCCESS = '@@b2b_portal_ui/authorization/GET_TEMPORARY_PASSWORD_SUCCESS';
export const GET_TEMPORARY_PASSWORD_FAILURE = '@@b2b_portal_ui/authorization/GET_TEMPORARY_PASSWORD_FAILURE';

export const initialChangePasswordState: IChangePasswordState = {
    alphabet: '',
    error: '',
    maxLength: 0,
    minLength: 0,
    requiredDigit: false,
    requiredLetter: false,
};
